import { Theme, styled } from '@material-ui/core';

const BookTitle = styled('span')<Theme>(({ theme }) => ({
  width: '10rem',
  textAlign: 'center',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  backgroundColor: 'rgba(0, 0, 0, 0.12)',
  padding: theme.spacing(2),
  fontWeight: 700,
  fontSize: theme.typography.h4.fontSize,
  marginRight: theme.spacing(3),
}));

export default BookTitle;
